import React, { useContext, useEffect, useState } from "react";
import { Table, Button, Modal, Empty } from "antd";
import { Dropdown as DropdownSemantic} from "semantic-ui-react";
import { EvaluacionHojasdeVidaModel } from "./Modal/EvaluacionHojasdeVidaModel";
import "./styleCss.scss";
import { useInscribirHojaJurados } from "../../../hooks/useInscribirHojaJurados";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import moment from "moment";
import { TemplateContext } from "../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import { itemRenderTable } from "../../../utils/itemRenderTable";
// @ts-ignore
export default function EvaluacionHojasdeVidaList(props: any) {
  const [visible, setVisible] = useState(false);
  const context = useContext(TemplateContext);
  const [cantidadPáginas, setCantidadPáginas] = React.useState(10);
  const { proyectosSeguimiento, criteriosEvaluacion, consultarHojadeVidaJuradoCriterioProyecto } = useInscribirHojaJurados();
  const [proyectoVisualizar, setProyectoVisualizar] = useState<any>();
  const [matchScreen, setMatchScreen] = useState<any>("");





  useEffect(() => {
    consultarHojadeVidaJuradoCriterioProyecto();
  }, []);

  useEffect(() => {
    let mobileQuery = window.matchMedia("(max-width: 768px)");
    mediaQueryCheck(mobileQuery);
    mobileQuery.addEventListener("change", mediaQueryCheck);
    return () => {
      mobileQuery.removeEventListener("change", mediaQueryCheck);
    };
  }, [matchScreen]);
  function mediaQueryCheck(inputQuery: any) {
    if (inputQuery.matches) {
      setMatchScreen(true);
    } else {
      setMatchScreen(false);
    }
  }
  const mostrarProyectos = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };
  const columns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 30,
      render: (data: any, data2: any, index: number) => {
        return <span>{index + 1}</span>;
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Puntaje final</span>,
      render: (data: any) => {
        //
        if (data.proyecto.nota_final > 0) {
          return (
            <span className="font-color-00904C">
              {data.proyecto.nota_final}
            </span>
          );
        }
      },
      width: 70,
    },
    {
      title: <span className="as_tbl_hd">Codigo</span>,
      render: (data: any) => {
        return (
          <span className="font-color-00904C">{data.proyecto.radicado}</span>
        );
      },
      width: 60,
    },
    {
      title: <span className="as_tbl_hd">Fecha act.</span>,
      // dataIndex: "fechaact",
      key: "4",
      width: 60,
      render: (data: any) => {
        if (data.proyecto.fecha_actualizacion) {
          return (
            <span>
              {moment(data.proyecto.fecha_actualizacion).format("DD/MM/YYYY")}
            </span>
          );
        }
        return <span></span>;
      },
    },
    {
      title: <span className="as_tbl_hd">Acciones</span>,
      key: "acciones",
      fixed: context.device === "lg" ? "right" : false,
      width: 70,
      render: (datos: any) => (
          <div className="col-12 justify-content-center">
            <Button
              onClick={() => {
                console.log(datos, 'datos')
                setProyectoVisualizar(datos);
                setVisible(true);
              }}
              className="no-margin button-azul-ghost font-family-Montserrat-Medium"
            >
              Ver Más
            </Button>
          </div>
      ),
    },
  ];
  const [isTerm, setIsTerm] = useState(false);
  const onCancel = () => {
    setIsTerm(false);
    setVisible(false);
  };
  return (
    // @ts-ignore
    <div>
      <div style={{ background: "red" }}>
        <Modal
          // title="Evaluacion deProyectosList"
          centered
          visible={visible}
          onOk={() => setVisible(false)}
          onCancel={onCancel}
          width={1600}
          maskStyle={{
            background: "rgba(6, 100, 144,0.8)",
          }}
          className="eval_pro_model mt-2"
          footer={false}
        >
          <EvaluacionHojasdeVidaModel
            setVisible={setVisible}
            evalProyectoPage={"informacionProyectosList"}
            proyectosJurado={proyectoVisualizar}
            criterios={criteriosEvaluacion}
            jurado={props.jurado}
            consultarHojadeVidaJuradoCriterioProyecto={
              consultarHojadeVidaJuradoCriterioProyecto
            }
            isTerm={isTerm}
            setIsTerm={setIsTerm}
          />
        </Modal>

      </div>
      <div className="row mt-4">
        <div className="col-12 font-size-18px text-start font-family-Montserrat-Regular">
          <span className="font-family-Montserrat-SemiBold">
            A continuación se listarán las Hojas de vida que se le asignaron.
          </span>{" "}
          Recuerde que debe completar todas las evaluaciones asignadas para
          poder enviarlas.
        </div>
        <div className="col-12 mt-3">
          <div className="row-shadow2 ms-1">
            <div className="row">
              <div className="col-12 justify-content-start text-start col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
                Hoja de vida a evaluar
              </div>
              <div className="col-12 col-md-6 pb-2">
                <div className="row g-2">
                  <div className="col-10 col-md-10  col-xl-10 col-xxl-11 d-flex justify-content-end align-content-center">
                    <span className="pe-4 col d-flex justify-content-md-end">
                      Total :{" "}
                      <span className="font-color-F28C02">
                        {proyectosSeguimiento.length}
                      </span>
                    </span>
                    <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                      Registros por página
                    </span>
                  </div>
                  <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                    <DropdownSemantic
                      fluid
                      className="select-registros-adminconvocatoria no-margin"
                      defaultValue={cantidadPáginas}
                      options={cantidadRegistros}
                      icon={<IconFlechareg />
                      }
                      onChange={(e, { value }) => mostrarProyectos(e, value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            {console.log(proyectosSeguimiento, 'proyectosSeguimiento')}
            <div className="col-12">
              <Table
                columns={columns}
                style={{ borderTop: "1px solid #C4C4C4" }}
                locale={{
                  emptyText: (
                    <Empty
                      description="No se han diligenciados datos para está sección"
                      style={{ padding: "50px" }}
                    />
                  ),
                }}
                pagination={{
                  position: ["bottomRight"],
                  itemRender: itemRenderTable,
                  pageSize: cantidadPáginas,
                }}
                dataSource={proyectosSeguimiento}
                scroll={{ x: "calc(590px + 50%)", y: 340 }}
                size="small"
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-dark" : "table-row-light"
                }
                bordered={false}
              />
            </div>
            <div className="col-12 justify-content-flex-end">
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
